import React from "react"

function ListItem(props) {
    return(
        <div>

            <li>{props.li.text}</li><br/>

        </div>
    
    )
}

export default ListItem